<template>
  <div>
    <app-spinner v-if="!schedule_taxi" />
    <template v-else>
      <app-schedule :schedule="schedule_taxi" />
    </template>
  </div>
</template>

<script>
import AppSchedule from '@/components/AppSchedule'

export default {
  name: 'TransferScheduleTaxi',
  components: { AppSchedule },
  props: {
    schedule_taxi: Object
  },
}
</script>
